import {fetchBaseQuery} from '@reduxjs/toolkit/query';
import {createApi} from '@reduxjs/toolkit/query/react';

import {
  GetConversationDetailParams,
  GetConversationDetailResponse,
  getConversationDetailParams,
  getConversationDetailResponse,
  GetConversationEventsParams,
  GetConversationEventsResponse,
  getConversationEventsParams,
  getConversationEventsResponse,
  ReadAllConversationEventsParams,
  readAllConversationEventsParams,
  SendEventAsPublicUserParams,
  SendEventAsPublicUserBody,
  sendEventAsPublicUserParams,
  sendEventAsPublicUserBody,
} from '@chat/shared/validations';

export const chatPublicApi = createApi({
  reducerPath: 'chatPublicApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.CHAT_FE_API_URL,
    prepareHeaders: (headers) => {
      headers.set('x-request-id', window.crypto.randomUUID());
      return headers;
    },
  }),
  tagTypes: ['Messages', 'Conversation'],
  endpoints: (build) => ({
    getPublicEvents: build.query<GetConversationEventsResponse, GetConversationEventsParams>({
      query: ({conversationId}) => ({
        url: `/public/api/v2/conversation/${conversationId}/events`,
      }),
      extraOptions: {
        requestSchema: getConversationEventsParams,
        responseSchema: getConversationEventsResponse,
      },
    }),
    createPublicEvent: build.mutation<
      void,
      SendEventAsPublicUserParams & SendEventAsPublicUserBody
    >({
      query: ({conversationId, content}) => ({
        url: `/public/api/v2/conversation/${conversationId}/events`,
        method: 'POST',
        body: {content},
      }),
      extraOptions: {
        requestSchema: sendEventAsPublicUserParams.merge(sendEventAsPublicUserBody),
      },
    }),
    markPublicEventsAsRead: build.mutation<void, ReadAllConversationEventsParams>({
      query: ({conversationId}) => ({
        url: `/public/api/v2/conversation/${conversationId}/events/read-all`,
        method: 'POST',
      }),
      extraOptions: {
        requestSchema: readAllConversationEventsParams,
      },
    }),
    getPublicConversation: build.query<GetConversationDetailResponse, GetConversationDetailParams>({
      query: ({conversationId}) => ({
        url: `/public/api/v2/conversation/${conversationId}`,
      }),
      extraOptions: {
        requestSchema: getConversationDetailParams,
        responseSchema: getConversationDetailResponse,
      },
    }),
  }),
});

export const {
  useGetPublicEventsQuery,
  useCreatePublicEventMutation,
  useMarkPublicEventsAsReadMutation,
  useGetPublicConversationQuery,
} = chatPublicApi;
